import { environment } from '@/_shared/configuration/env';
import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USERS_ACTIVE_CONTEXT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USERS_AUTHORIZE_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_SET_ORGANIZATION_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USERS_WARNINGS_PATH_KEY,
  API_ORGANIZATIONS_PATH_KEY,
} from '@/swagger/constants/slash-keys';

export const API_ORGANIZATIONS = () => {
  return buildEndpointUrl(API_ORGANIZATIONS_PATH_KEY, {});
};

export const API_USER_PROFILE = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_ORGANIZATION_CONFIG = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_ORGANIZATION_CONFIG = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_PATH_KEY, {
    organizationId: org,
  });
};

export const API_PUT_ACTIVATE_CONTEXT = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USERS_ACTIVE_CONTEXT_PATH_KEY, {
    organizationId: org,
  });
};

export const API_SET_ORGANIZATION = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USERS_ME_SET_ORGANIZATION_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_USER_WARNINGS = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USERS_WARNINGS_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_USER_AUTHORIZE = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USERS_AUTHORIZE_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_CONTACT = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY, {
    organizationId: org,
  });
};

// TODO: not used for now, but might be useful in the future
export const API_PUT_SET_LANGUAGE = (org: string) => {
  const baseUrl = `${environment.VITE_APP_HOST_API_BASE}/organizations/${org}/users/me/set-language`;
  return baseUrl;
};
